"use client";
import { useTheme } from "next-themes";
import { usePathname } from "next/navigation";
import { useEffect } from "react";
import CustomHeader from "./synergy/components/CustomHeader";
import MarketingNavbar from "@/components/navbar/marketing-navbar";

export default function AppLayout({ children }: { children: React.ReactNode }) {
  const { setTheme } = useTheme();
  const pathname = usePathname();

  useEffect(() => {
    setTheme("light"); // Set the theme to dark when this component mounts
    return () => setTheme("system"); // Reset to light theme when this component unmounts
  }, [setTheme]);

  return (
    <div className="max-w-screen overflow-hidden">
      {/* {pathname !== "/synergy" && <MarketingNavbar />} */}
      <CustomHeader />
      <div>{children}</div>
    </div>
  );
}
